import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill='currentColor'
      d='m12 13-.573.82a1 1 0 0 0 1.146 0zM4 5h16V3H4zm16 0c.548 0 1 .452 1 1h2c0-1.652-1.348-3-3-3zm1 1v12h2V6zm0 12c0 .548-.452 1-1 1v2c1.652 0 3-1.348 3-3zm-1 1H4v2h16zM4 19c-.548 0-1-.452-1-1H1c0 1.652 1.348 3 3 3zm-1-1V6H1v12zM3 6c0-.548.452-1 1-1V3C2.348 3 1 4.348 1 6zm18.427-.82-10 7 1.146 1.64 10-7zm-8.853 7-10-7-1.147 1.64 10 7z'
    />
  </svg>
);
export default SvgMail;
